<template>
  <div class="btn-box" @click="showConsultationModal">
    <img alt="泰坦智慧" title="titanos" :src="require('../../assets/' + assetsConfig.consultation.icon)">
    <span>
      立即咨询
    </span>
  </div>
</template>

<script>
export default {
  name: 'icon-button',
  data() {
    return {
      assetsConfig: ASSETS_CONFIG
    }
  },
  methods: {
    showConsultationModal() {
      this.$emit('on-show', true)
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-box
  background-color #186dff
  width 36px
  padding 8px
  text-align center
  color #fff
  position fixed
  right 10px
  top 50%
  transform translateY(-50%)
  border-radius 4px
  cursor pointer
  user-select none
  height 115px
  z-index 100
  img
    width 20px
    height 20px
  span
    line-height 0.8
</style>


// WEBPACK FOOTER //
// src/components/basic/IconButton.vue